
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[[...jobId]]",
      function () {
        return require("private-next-pages/jobs/[[...jobId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[[...jobId]]"])
      });
    }
  